import { useCallback } from 'react';

import { type Library } from '@air/api/types';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackReorderedLibraries.meta';

export type UseTrackReorderedLibrariesParams = {
  library_id: Library['id'];
};

export const useTrackReorderedLibraries = () => {
  const { track } = useAnalyticsUtilities();

  const trackReorderedLibraries = useCallback(
    (params: UseTrackReorderedLibrariesParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackReorderedLibraries };
};
